import { provider } from "../../providers";

export interface LeaveGroupPayload {
  groupId: number;
  playerId: number;
}

export const LeaveGroup = async (params: LeaveGroupPayload): Promise<boolean> =>
  provider.Request("/leave-group", params);
